import { ReactNode } from 'react';
import classNames from 'classnames/bind';

import styles from './RenderCell.module.css';
const classNameCtx = classNames.bind(styles);

interface RenderCellProps {
  primarySlot?: ReactNode;
  secondarySlot?: ReactNode;
  tertiarySlot?: ReactNode;
  /** Removes the padding indentation of the secondary slot */
  disableIndentation?: boolean;
  editable?: boolean;
}

/**
 * Component for rendering Dispatch Board Grid cells with a unified look and feel.
 * Consuming components define the content of the cell using the Primary slot and optional Secondary slot.
 */
export default function RenderCell(props: RenderCellProps) {
  const secondaryClasses = classNameCtx({
    'secondary-slot': true,
    'no-padding': props.disableIndentation
  });

  return (
    <>
      {props.primarySlot && <div className={`${styles['primary-slot']} ${styles.ellipsis}`}>{props.primarySlot}</div>}

      {(props.secondarySlot || props.tertiarySlot) && (
        <div className={secondaryClasses}>
          {props.secondarySlot && <div className={styles.ellipsis}>{props.secondarySlot}</div>}

          {props.tertiarySlot && <div className={styles['tertiary-slot']}>{props.tertiarySlot}</div>}
        </div>
      )}
    </>
  );
}
